export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-02.390bfbbf.svg";